import { initFavicon } from './favicon';

export const initProjectTheme = (): void => {
  if (typeof document === 'undefined') return;
  document.title = 'askAltronic';
  initFavicon();
};
